var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"28","cy":"28","r":"27","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M17 28H38","stroke":"white","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M30 20L38.5 28L30 36","stroke":"white","strokeWidth":"2","key":2})]);
}

RightArrowInline.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
